import React from 'react';
import OffersPage from './OffersPage';
// Keep the standalone creation layout isolated from the shared modal styles.
import './NewOfferPage.css';

// Reuse the single full offer form in a protected standalone page.
const NewOfferPage = () => <OffersPage creationMode />;

export default NewOfferPage;
